import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import CertificateActivityLogs from "../pages/ExamController/Certificate/CertificateActivityLogs/CertificateActivityLogs";
import CertificateList from "../pages/ExamController/Certificate/CertificateList/CertificateList";
import PreviewCertificate from "../pages/ExamController/Certificate/PreviewCertificate/PreviewCertificate";
import ViewCertificate from "../pages/ExamController/Certificate/ViewCertificate/ViewCertificate";
import Dashboard from "../pages/ExamController/Dashboard/Dashboard";
import Profile from "../pages/ExamController/Profile/Profile";
import UserActivityLogs from "../pages/ExamController/Profile/UserActivityLogs/UserActivityLogs";

var ExamControllerRoutes = [
    {
    path: "dashboard",
    name: "Dashboard",
    element: <Dashboard/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "view-certificate",
    name: "View Certificate",
    element: <ViewCertificate/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/activity-logs/:certificate_id",
    name: "Certificate Activity Logs",
    element: <CertificateActivityLogs/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "my-profile",
    name: "My Profile",
    element: <Profile/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "my-activities",
    name: "My Activities",
    element: <UserActivityLogs/>,
    layout: "controller",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default ExamControllerRoutes;
